import { render } from "./Group-page.vue?vue&type=template&id=576db58a"
import script from "./Group-page.vue?vue&type=script&lang=js"
export * from "./Group-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__